var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./inscripcio-modal.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-64925139\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./inscripcio-modal.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/home/components/inscripcio-modal/inscripcio-modal.vue
// module id = 264
// module chunks = 0